
import React from 'react';
import CustomersHeader from './CustomersHeader';
import CustomersListView from './CustomersListView';

interface CustomersContentProps {
  customers: any[];
  loading: boolean;
  selectedCustomers: string[];
  deleting: boolean;
  onAddCustomer: () => void;
  onEditCustomer: (id: string) => void;
  onDeleteCustomer: (id: string) => Promise<boolean>;
  onBulkDelete: () => void;
  toggleSelection: (id: string) => void;
  toggleSelectAll: () => void;
  allSelected: boolean;
  shopId?: string;
}

const CustomersContent = ({
  customers,
  loading,
  selectedCustomers,
  deleting,
  onAddCustomer,
  onEditCustomer,
  onDeleteCustomer,
  onBulkDelete,
  toggleSelection,
  toggleSelectAll,
  allSelected,
  shopId
}: CustomersContentProps) => {
  return (
    <div className="container mx-auto px-4 py-6 space-y-8 bg-pastel-blue-light dark:bg-[#121624]">
      <CustomersHeader
        selectedCount={selectedCustomers.length}
        onDelete={onBulkDelete}
        onAddCustomer={onAddCustomer}
        isAdding={false}
        shopId={shopId}
        selectedCustomers={selectedCustomers}
      />
      
      <CustomersListView
        customers={customers}
        selectedCustomers={selectedCustomers}
        loading={loading}
        toggleSelection={toggleSelection}
        toggleSelectAll={toggleSelectAll}
        allSelected={allSelected}
        deleting={deleting}
        totalCount={customers.length}
        handleEdit={onEditCustomer}
        handleDelete={onDeleteCustomer}
        onAddCustomer={onAddCustomer}
        onBulkDelete={onBulkDelete}
      />
    </div>
  );
};

export default CustomersContent;
